import React, { useState, useEffect } from 'react';
import {
  getSedes,
  crearSede,
  actualizarSede,
  eliminarSede,
  getEstadisticasSede,
} from '../../services/api';

function Sedes() {
  const [sedes, setSedes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showStatsModal, setShowStatsModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [estadisticas, setEstadisticas] = useState(null);
  const [formData, setFormData] = useState({
    nombre: '',
    codigo: '',
    direccion: '',
    telefono: '',
    activo: true,
    ofrece_almuerzo: true,
    ofrece_cena: false,
  });
  const [mensaje, setMensaje] = useState(null);

  useEffect(() => {
    cargarSedes();
  }, []);

  const cargarSedes = async () => {
    try {
      const res = await getSedes();
      setSedes(res.data);
    } catch (error) {
      console.error('Error cargando sedes:', error);
      mostrarMensaje('Error al cargar sedes', 'error');
    }
  };

  const abrirModal = (sede = null) => {
    if (sede) {
      setEditando(sede.id);
      setFormData({
        nombre: sede.nombre,
        codigo: sede.codigo,
        direccion: sede.direccion || '',
        telefono: sede.telefono || '',
        activo: sede.activo,
        ofrece_almuerzo: sede.ofrece_almuerzo ?? true,
        ofrece_cena: sede.ofrece_cena ?? false,
      });
    } else {
      setEditando(null);
      setFormData({
        nombre: '',
        codigo: '',
        direccion: '',
        telefono: '',
        activo: true,
        ofrece_almuerzo: true,
        ofrece_cena: false,
      });
    }
    setShowModal(true);
  };

  const cerrarModal = () => {
    setShowModal(false);
    setEditando(null);
    setFormData({
      nombre: '',
      codigo: '',
      direccion: '',
      telefono: '',
      activo: true,
      ofrece_almuerzo: true,
      ofrece_cena: false,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validar que al menos ofrezca almuerzo o cena
    if (!formData.ofrece_almuerzo && !formData.ofrece_cena) {
      mostrarMensaje('La sede debe ofrecer al menos almuerzo o cena', 'error');
      return;
    }

    try {
      if (editando) {
        await actualizarSede(editando, formData);
        mostrarMensaje('Sede actualizada exitosamente', 'success');
      } else {
        await crearSede(formData);
        mostrarMensaje('Sede creada exitosamente', 'success');
      }
      cerrarModal();
      cargarSedes();
    } catch (error) {
      console.error('Error guardando sede:', error);
      mostrarMensaje(
        error.response?.data?.error || 'Error al guardar sede',
        'error'
      );
    }
  };

  const handleEliminar = async (id, nombre) => {
    if (!window.confirm(`¿Estás seguro de desactivar la sede "${nombre}"?`)) {
      return;
    }

    try {
      await eliminarSede(id);
      mostrarMensaje('Sede desactivada exitosamente', 'success');
      cargarSedes();
    } catch (error) {
      console.error('Error eliminando sede:', error);
      mostrarMensaje(
        error.response?.data?.error || 'Error al desactivar sede',
        'error'
      );
    }
  };

  const verEstadisticas = async (id) => {
    try {
      const res = await getEstadisticasSede(id);
      setEstadisticas(res.data);
      setShowStatsModal(true);
    } catch (error) {
      console.error('Error cargando estadísticas:', error);
      mostrarMensaje('Error al cargar estadísticas', 'error');
    }
  };

  const mostrarMensaje = (texto, tipo) => {
    setMensaje({ texto, tipo });
    setTimeout(() => setMensaje(null), 3000);
  };

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Gestión de Sedes</h2>
        <button className="btn btn-primary" onClick={() => abrirModal()}>
          ➕ Nueva Sede
        </button>
      </div>

      {mensaje && (
        <div className={`alert alert-${mensaje.tipo === 'success' ? 'success' : 'danger'}`}>
          {mensaje.texto}
        </div>
      )}

      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Nombre</th>
                  <th>Dirección</th>
                  <th>Teléfono</th>
                  <th>Ofrece</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {sedes.map((sede) => (
                  <tr key={sede.id}>
                    <td>
                      <span className="badge bg-primary">{sede.codigo}</span>
                    </td>
                    <td>{sede.nombre}</td>
                    <td>{sede.direccion || '-'}</td>
                    <td>{sede.telefono || '-'}</td>
                    <td>
                      {(() => {
                        const ofreceAlmuerzo = sede.ofrece_almuerzo === 1 || sede.ofrece_almuerzo === true;
                        const ofreceCena = sede.ofrece_cena === 1 || sede.ofrece_cena === true;
                        
                        if (ofreceAlmuerzo && ofreceCena) {
                          return <span className="badge bg-success">Almuerzo y Cena</span>;
                        } else if (ofreceAlmuerzo) {
                          return <span className="badge bg-info">Almuerzo</span>;
                        } else if (ofreceCena) {
                          return <span className="badge bg-warning">Cena</span>;
                        } else {
                          return '-';
                        }
                      })()}
                    </td>
                    <td>
                      {sede.activo ? (
                        <span className="badge bg-success">Activa</span>
                      ) : (
                        <span className="badge bg-secondary">Inactiva</span>
                      )}
                    </td>
                    <td>
                      <button
                        className="btn btn-sm btn-info me-2"
                        onClick={() => verEstadisticas(sede.id)}
                        title="Ver estadísticas"
                      >
                        📊
                      </button>
                      <button
                        className="btn btn-sm btn-warning me-2"
                        onClick={() => abrirModal(sede)}
                        title="Editar"
                      >
                        ✏️
                      </button>
                      {sede.activo && (
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleEliminar(sede.id, sede.nombre)}
                          title="Desactivar"
                        >
                          🗑️
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal de formulario */}
      {showModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editando ? 'Editar Sede' : 'Nueva Sede'}
                </h5>
                <button type="button" className="btn-close" onClick={cerrarModal}></button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Nombre *</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.nombre}
                      onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Código *</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.codigo}
                      onChange={(e) => setFormData({ ...formData, codigo: e.target.value.toUpperCase() })}
                      required
                      maxLength="20"
                      placeholder="Ej: CENTRAL, NORTE, SUR"
                    />
                    <small className="text-muted">Código corto para identificación rápida</small>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Dirección</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.direccion}
                      onChange={(e) => setFormData({ ...formData, direccion: e.target.value })}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Teléfono</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.telefono}
                      onChange={(e) => setFormData({ ...formData, telefono: e.target.value })}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Tipo de comida que ofrece</label>
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="ofreceAlmuerzo"
                        checked={formData.ofrece_almuerzo}
                        onChange={(e) => setFormData({ ...formData, ofrece_almuerzo: e.target.checked })}
                      />
                      <label className="form-check-label" htmlFor="ofreceAlmuerzo">
                        Ofrece almuerzo
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="ofreceCena"
                        checked={formData.ofrece_cena}
                        onChange={(e) => setFormData({ ...formData, ofrece_cena: e.target.checked })}
                      />
                      <label className="form-check-label" htmlFor="ofreceCena">
                        Ofrece cena
                      </label>
                    </div>
                    <small className="text-muted">Debes seleccionar al menos una opción</small>
                  </div>
                  <div className="mb-3 form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="activo"
                      checked={formData.activo}
                      onChange={(e) => setFormData({ ...formData, activo: e.target.checked })}
                    />
                    <label className="form-check-label" htmlFor="activo">
                      Sede activa
                    </label>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={cerrarModal}>
                    Cancelar
                  </button>
                  <button type="submit" className="btn btn-primary">
                    {editando ? 'Actualizar' : 'Crear'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Modal de estadísticas */}
      {showStatsModal && estadisticas && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Estadísticas - {estadisticas.sede}</h5>
                <button type="button" className="btn-close" onClick={() => setShowStatsModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-6 mb-3">
                    <div className="card text-center">
                      <div className="card-body">
                        <h3>{estadisticas.estadisticas.usuarios}</h3>
                        <p className="mb-0">Usuarios</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 mb-3">
                    <div className="card text-center">
                      <div className="card-body">
                        <h3>{estadisticas.estadisticas.sectores}</h3>
                        <p className="mb-0">Sectores</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 mb-3">
                    <div className="card text-center">
                      <div className="card-body">
                        <h3>{estadisticas.estadisticas.pedidosHoy}</h3>
                        <p className="mb-0">Pedidos Hoy</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 mb-3">
                    <div className="card text-center">
                      <div className="card-body">
                        <h3>{estadisticas.estadisticas.pedidosMes}</h3>
                        <p className="mb-0">Pedidos Este Mes</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowStatsModal(false)}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Sedes;
